import { begin, end, pendingTask } from "react-redux-spinner";

import {
  IUpdateUserApiKey,
  IDeleteUserApiKey,
  ICreateUserApiKey,
  adminUserUpdateResponse
} from "../../admin.actions";
import { put } from "redux-saga/effects";
import AdminService from "../../admin.service";
import AdminFeedback from "../../admin.feedback";

export function* updateApiKey(action: IUpdateUserApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { userId, newDate, newName, oldName } = action.payload;
    const adminService = new AdminService();
    const user = yield adminService.updateUserApiKey(
      userId,
      newDate,
      newName,
      oldName
    );
    yield put(adminUserUpdateResponse(user, AdminFeedback.API_KEY_EDITED));
  } catch (error) {
    yield put(
      adminUserUpdateResponse(error, AdminFeedback.API_KEY_EDIT_FAILED)
    );
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* deleteApiKey(action: IDeleteUserApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { userId, tokenName } = action.payload;

    const adminService = new AdminService();
    const user = yield adminService.deleteUserApiKey(userId, tokenName);
    yield put(adminUserUpdateResponse(user, AdminFeedback.API_KEY_REMOVED));
  } catch (error) {
    yield put(
      adminUserUpdateResponse(error, AdminFeedback.API_KEY_REMOVE_FAILED)
    );
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* createApiKey(action: ICreateUserApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { userId } = action.payload;
    const adminService = new AdminService();
    const user = yield adminService.createUserApiKey(userId);
    yield put(adminUserUpdateResponse(user, AdminFeedback.API_KEY_CREATED));
  } catch (error) {
    adminUserUpdateResponse(error, AdminFeedback.API_KEY_CREATE_FAILED);
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}
